/**
 * Chinese (Simplified, PRC) locale settings for Webix.
 */
webix.i18n.locales['zh-CN'] = {
    groupDelimiter: ',', // Delimiter for groups of thousands
    groupSize: 3, // Size of groups of thousands
    decimalDelimiter: '.', // Delimiter for decimal part
    decimalSize: 2, // Number of decimal places
    dateFormat: '%Y/%m/%j', // Date format
    timeFormat: '%G:%i', // Time format
    longDateFormat: "%Y'年'%m'月'%j'日'", // Long date format
    fullDateFormat: "%Y'年'%m'月'%j'日' %G:%i", // Full date and time format
    am: ['上午', '上午'], // AM markers
    pm: ['下午', '下午'], // PM markers
    price: '¥{obj}', // Price format
    priceSettings: {
        groupDelimiter: ',', // Delimiter for groups of thousands in prices
        groupSize: 3, // Size of groups of thousands in prices
        decimalDelimiter: '.', // Delimiter for decimal part in prices
        decimalSize: 2, // Number of decimal places in prices
    },
    calendar: {
        monthFull: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'], // Full names of months
        monthShort: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月',
        ], // Short names of months
        dayFull: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'], // Full names of days
        dayShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'], // Short names of days
        hours: '小时', // Label for hours
        minutes: '分钟', // Label for minutes
        done: '完成', // Label for done button
        clear: '清除', // Label for clear button
        today: '今天', // Label for today button
    },
    dataExport: {
        page: '页', // Label for page
        of: '从', // Label for of
    },
    PDFviewer: {
        of: '从', // Label for of
        automaticZoom: '自动设置页面大小', // Label for automatic zoom
        actualSize: '实际尺寸', // Label for actual size
        pageFit: '页面大小', // Label for page fit
        pageWidth: '页面宽度', // Label for page width
        pageHeight: '页面高度', // Label for page height
    },
    aria: {
        calendar: '日历', // ARIA label for calendar
        increaseValue: '增加值', // ARIA label for increase value
        decreaseValue: '减少值', // ARIA label for decrease value
        navMonth: ['上个月', '下个月'], // ARIA labels for navigating months
        navYear: ['上年', '明年'], // ARIA labels for navigating years
        navDecade: ['过去十年', '下个十年'], // ARIA labels for navigating decades
        dateFormat: "%Y'年'%m'月'%j'日'", // ARIA date format
        monthFormat: "%Y'年'%m'月", // ARIA month format
        yearFormat: "%Y'年", // ARIA year format
        hourFormat: '小时: %G', // ARIA hour format
        minuteFormat: '分钟: %i', // ARIA minute format
        removeItem: '删除元素', // ARIA label for removing item
        pages: ['第一页', '上一页', '下一页', '最后一页'], // ARIA labels for pages
        page: '页', // ARIA label for page
        headermenu: '标题菜单', // ARIA label for header menu
        openGroup: '打开栏目组', // ARIA label for opening column group
        closeGroup: '关闭栏目组', // ARIA label for closing column group
        closeTab: '关闭标签', // ARIA label for closing tab
        showTabs: '显示更多选项卡', // ARIA label for showing more tabs
        resetTreeMap: '回到原来的视图', // ARIA label for resetting tree map
        navTreeMap: '升级', // ARIA label for navigating tree map
        nextTab: '下一个标签', // ARIA label for next tab
        prevTab: '前一个标签', // ARIA label for previous tab
        multitextSection: '加元', // ARIA label for adding element
        multitextextraSection: '删除元素', // ARIA label for removing element
        showChart: '显示图表', // ARIA label for showing chart
        hideChart: '隐藏图表', // ARIA label for hiding chart
        resizeChart: '调整图', // ARIA label for resizing chart
    },
    richtext: {
        underline: '强调', // Label for underline
        bold: '粗體', // Label for bold
        italic: '斜体', // Label for italic
    },
    combo: {
        select: '选择', // Label for select
        selectAll: '全选', // Label for select all
        unselectAll: '全部取消选择', // Label for unselect all
    },
};

// FILE DOCUMENTED
